import type { LanguageIsoCodeEnum } from "@core/domain/models/language.model";
import type { LanguageRepository } from "@core/domain/repositories/language.repository";
import type { SelectOption } from "@core/domain/types/select-option.ts";
import { coreTypes } from "@core/root/core-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class LanguageGetAllUseCase {
    constructor(
        @inject(coreTypes.repositories.LanguageRepository)
        private readonly languagelRepository: LanguageRepository,
    ) {}

    execute(): SelectOption<LanguageIsoCodeEnum>[] {
        return this.languagelRepository.languageAll();
    }
}
